import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["flow", "nodeId", "extensionDefinitions"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getActionMetadataConfigFromAction } from 'automation-ui-action-features/actions/ActionMetadataConfigUtils';
import { createActionMap, getActionHeaderTitle } from 'automation-ui-action-features/records/recordsUtils';
import { getActionIconAndColorForType } from 'automation-ui-action-features/utils/actionThemeUtils';
import EnrollmentCard from 'automation-ui-canvas/components/enrollment/EnrollmentCard';
import { useGetIsUngated } from 'automation-ui-core/hooks/authHooks';
import AutomationBuilderCard from 'automation-ui-flow-core/canvas/AutomationBuilderCard';
import * as SpecialActionIds from 'automation-ui-flow-core/canvas/SpecialActionIds';
import styled from 'styled-components';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
// @bend-expect trellis-tokenized
const StyledGenericMessage = styled.div.withConfig({
  displayName: "ActionCardWithNoDetails__StyledGenericMessage",
  componentId: "qxh6zl-0"
})(["border:1px solid ", ";background-color:", ";border-radius:", ";line-height:normal;padding:", ";"], ({
  theme
}) => theme.color['border-caution-default'], ({
  theme
}) => theme.color['fill-caution-subtle'], ({
  theme
}) => theme.borderRadius['100'], ({
  theme
}) => theme.space['200']);
const CardMessage = () => {
  return /*#__PURE__*/_jsx(StyledGenericMessage, {
    "data-test-id": "card-message-for-changed-content",
    children: /*#__PURE__*/_jsx(Text, {
      typography: "detail-200",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation.enrollmentHistory.panel.enrollment-list.cardMessageForChangedContent"
      })
    })
  });
};
const ActionCardWithNoDetails = _ref => {
  let {
      flow,
      nodeId,
      extensionDefinitions
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const isUngated = useGetIsUngated();
  if (nodeId === SpecialActionIds.ENROLLMENT) {
    return /*#__PURE__*/_jsx(EnrollmentCard, Object.assign({}, restProps, {
      flow: flow,
      flowId: flow.flowId,
      flowObjectTypeId: flow.objectTypeId,
      Content: CardMessage,
      readOnly: true
    }));
  }
  const currentAction = flow.actions.get(Number(nodeId));
  const currentActionType = currentAction === null || currentAction === void 0 ? void 0 : currentAction.actionType;
  const actionMetadataConfig = currentActionType ? getActionMetadataConfigFromAction({
    actionType: currentActionType,
    metadata: currentAction.metadata
  }, undefined, extensionDefinitions) : null;
  let actionTypeSpecificProps = {};
  if (actionMetadataConfig) {
    const {
      iconName,
      iconUrl,
      theme
    } = getActionIconAndColorForType({
      actionMetadataConfig,
      extensionDefinition: extensionDefinitions[currentAction === null || currentAction === void 0 ? void 0 : currentAction.actionTypeId]
    });
    const flowActionMap = createActionMap(flow.toHybridFlowInterface());
    const getHeaderTitle = getActionHeaderTitle({
      flowActions: flowActionMap,
      firstActionId: flow.firstActionId,
      extensionDefinitions,
      isUngated
    });
    actionTypeSpecificProps = Object.assign({}, actionTypeSpecificProps, {
      headerIcon: iconName,
      headerImage: iconUrl,
      headerTitle: getHeaderTitle({
        actionId: currentAction === null || currentAction === void 0 ? void 0 : currentAction.actionId,
        useString: true
      }),
      titleUseTheme: theme
    });
  }
  return /*#__PURE__*/_jsx(AutomationBuilderCard, Object.assign({}, restProps, {
    content: /*#__PURE__*/_jsx(CardMessage, {})
  }, actionTypeSpecificProps));
};
export default ActionCardWithNoDetails;